export default class DtoDistributionCounterType {
    constructor(obj) {
        this.reportCode = obj.reportCode // Option[String],
        this.reportComment = obj.reportComment // Option[String],
        this.startYear = obj.startYear // Option[Int],
        this.endYear = obj.endYear // Option[Int],
        this.updateDate = obj.updateDate // Option[DateTime],
        this.updateLogin = obj.updateLogin // Option[String]
    }
}